// Components
import { Input } from 'components/form/inputs'

// Utils
import styles from './firstname.css'

type FirstNameProps = {
  onReview: boolean
  isEditing: boolean
  firstName: string | undefined
}

const validateName = (value: string) => {
  let error
  if (value.length < 2) {
    error = 'Are you sure? This name seems too short'
  }
  return error
}

const FirstName = (props: FirstNameProps): JSX.Element => {
  const { onReview, isEditing, firstName } = props

  if (!isEditing) {
    return (
      <div className={styles.displayWrapper}>
        <div className={styles.textData}>{firstName}</div>
      </div>
    )
  }

  return (
    <div className={styles.editingWrapper}>
      <Input
        className={styles.inputField}
        id="first_name"
        name="first_name"
        type="text"
        label={onReview && isEditing ? '' : 'First name'}
        autoComplete="given-name"
        validate={validateName}
      />
    </div>
  )
}

export default FirstName
